import React, { FC } from "react"

import { graphql } from "gatsby"

import { Layout } from "components/core/Layout"
import { PostLarge } from "components/core/Post"
import { Seo } from "components/core/Seo"
import { StayInTheLoop } from "components/core/StayInTheLoop"
import { Header } from "components/pages/Author/Header"
import { Author, Post } from "types"
import { Destination } from "types/destination"
import { getCanonicalUrl } from "utils/getCanonicalUrl"

import * as S from "./Author.styles"

interface TemplateAuthorProps {
  pageContext: {
    destinations: Destination[]
  }
  data: {
    author: Author
  }
  post: Post
}

export const TemplateAuthor: FC<TemplateAuthorProps> = ({
  data: { author },
  pageContext: { destinations },
}) => {
  const {
    posts: { nodes: posts },
  } = author

  const canonical = getCanonicalUrl(author.uri)
  const seoTitle = `${author.seo?.title} ${author.firstName} ${author.lastName}`
  const totalPostsOfAuthor = posts?.length

  return (
    <Layout isAuthorPage destinations={destinations}>
      <Seo post={author} title={seoTitle} />
      <Header author={author} />
      <S.Container>
        {totalPostsOfAuthor && (
          <S.TotalNumberPostsContainer>
            <S.TotalNumberPosts>
              {totalPostsOfAuthor}{" "}
              {totalPostsOfAuthor === 1 ? "story" : "stories"}
            </S.TotalNumberPosts>
            <S.Line />
          </S.TotalNumberPostsContainer>
        )}
        {posts?.map((post: Post) => {
          return <PostLarge key={post.id} post={post} />
        })}
      </S.Container>
      <StayInTheLoop canonical={canonical} source="Blog - Author" />
    </Layout>
  )
}

export default TemplateAuthor

export const pageQuery = graphql`
  query AuthorById($id: String!) {
    author: wpUser(id: { eq: $id }) {
      description
      firstName
      id
      lastName
      uri
      avatar {
        url
      }
      posts {
        nodes {
          date(formatString: "MMMM DD, YYYY")
          id
          title
          excerpt
          uri
          categories {
            nodes {
              name
              slug
              uri
              seo {
                breadcrumbs {
                  text
                  url
                }
              }
            }
          }
          featuredImage {
            node {
              altText
              sourceUrl
            }
          }
        }
      }
      seo {
        canonical
        metaDesc
        title
        schema {
          raw
        }
        social {
          facebook
          instagram
          linkedIn
          twitter
        }
      }
    }
  }
`
